import React, { useEffect, useState } from "react";
import SC from "./style";
import Googlesignin from "views/googlelogin";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "@store/auth/actions";
import CryptoJS from "crypto-js";
import Cursor from "../../../assets/icons/Cursor.png";
import { readFromLocalStorage, saveToLocalStorage } from "utils/helper";

const { REACT_APP_CRYPTO_KEY } = process.env;
const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, REACT_APP_CRYPTO_KEY).toString();
};

const LoginPage = ({ setCurrentView }) => {
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.authdata);
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [userData, setUserData] = useState({
    userName: "",
    password: "",
  });

  useEffect(() => {
    const tempUserName = readFromLocalStorage("userName", userData.userName);
    setUserData({
      userName: tempUserName ? tempUserName : "",
      password: "",
    });

    setRemember(readFromLocalStorage("remember") === "1" ? true : false);
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const tempUserData = {
      userName: userData.userName,
    };
    try {
      if (userData.password !== "") {
        const encryptpass = encryptPassword(userData.password);
        tempUserData.password = encryptpass;
      }
      dispatch(auth(tempUserData));
      if (remember) {
        saveToLocalStorage("remember", "1");
        saveToLocalStorage("userName", userData.userName);
      } else {
        localStorage.removeItem("remember");
        localStorage.removeItem("userName");
      }
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };
  return (
    <>
     
      <SC.LoginForm>
        <SC.Heading>Welcome!</SC.Heading>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Googlesignin />
        </div>
        <SC.Form onSubmit={handleLogin}>
          <SC.Label style={{ fontSize: "12px" }}>Username</SC.Label>
          <SC.TransparentInput
            type="text"
            name="userName"
            placeholder="Enter Username"
            value={userData.userName}
            onChange={handleInputChange}
            required
          />
          <SC.Label style={{ fontSize: "12px" }}>Password</SC.Label>
          <SC.PasswordInputContainer>
            <SC.TransparentInputt
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter Password"
              value={userData.password}
              onChange={handleInputChange}
              required
            />
            <SC.ToggleButton onClick={togglePasswordVisibility} type="button">
              {showPassword ? <SC.VisibilityIcon /> : <SC.VisibilityOffIcon />}
            </SC.ToggleButton>
          </SC.PasswordInputContainer>
          <SC.Forgetdiv>
            <SC.checkboxdiv>
              <input
                type="checkbox"
                style={{
                  fontSize: "12px",
                  accentColor: remember ? "#EA7006" : "initial", // Checkbox color to red when checked
                  backgroundColor: remember ? "#EA7006" : "initial", // Background color red when checked
                  color: remember ? "white" : "initial", // Color of the checkmark when checked
                }}
                onClick={(e) => {
                  setRemember(e.target.checked);
                }}
                onChange={(e) => {}}
                checked={remember}
              />
              <span style={{ fontSize: "12px" }}>Remember me</span>
            </SC.checkboxdiv>
            <div
              style={{ cursor: "pointer", fontSize: "12px" }}
              onClick={() => setCurrentView("forgetpass")}
            >
              <SC.Forgetpass>Forgot Password</SC.Forgetpass>
            </div>
          </SC.Forgetdiv>
          <SC.Button type="submit" disabled={authData.isAuthenticating}>
            {authData.isAuthenticating ? "Sign in.." : "Sign in"}
          </SC.Button>
        </SC.Form>
        <SC.Requestdiv>
          <div
            style={{
              cursor: "pointer",
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => setCurrentView("requestaccess")}
          >
            <img src={Cursor} alt="cursor icon" />
            <SC.RequestAccessunderline>
              Request Access
            </SC.RequestAccessunderline>
          </div>
        </SC.Requestdiv>
        {authData.error && <SC.ErrorMessage>{authData.error}</SC.ErrorMessage>}
      </SC.LoginForm>
    </>
  );
};

export default LoginPage;
